export const CONTENT_UPDATE = 'cms/CONTENT_UPDATE';
export const NAVIGATION_UPDATE = 'cms/NAVIGATION_UPDATE';
export const SLIDER_UPDATE = 'cms/SLIDER_UPDATE';

export const contentUpdate = (data) => ({
  type: CONTENT_UPDATE,
  data
});

export const navigationUpdate = (data) => ({
  type: NAVIGATION_UPDATE,
  data
});

export const sliderUpdate = (data) => ({
  type: SLIDER_UPDATE,
  data
});
